import { BaseTheme, Button, styled } from 'opensolar-ui'
import { OpenSolarPalette } from 'Themes'

/** Reserve space at bottom so content doesn't sit under the fixed footer (Discard / Share For Review bar). */
const FIXED_FOOTER_HEIGHT_PX = 88
/** On mobile, add extra space so content doesn't sit under the footer + app bottom nav. Kept generous so the Add Item button isn't obscured during nav/footer transitions. */
const MOBILE_BOTTOM_PADDING_PX = 152

export const ContentWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  padding: '24px 12px',
  paddingBottom: FIXED_FOOTER_HEIGHT_PX,
  width: '100%',
  boxSizing: 'border-box',
  flexGrow: 1,
  /** Match page background so the bottom padding area doesn't show as a white block (parent e.g. SimpleForm is white). */
  backgroundColor: OpenSolarPalette.greyLight4,
  [theme.breakpoints.down('sm')]: {
    padding: '16px 8px',
    paddingBottom: MOBILE_BOTTOM_PADDING_PX,
  },
  /* Intermediate breakpoint: avoid cramped two-column; keep stacked layout comfortable. */
  [theme.breakpoints.between('sm', 'lg')]: {
    padding: '20px 12px',
  },
}))

export const ReviewQuoteCard = styled('div')({
  borderRadius: 8,
  backgroundColor: BaseTheme.palette.white,
})

export const ProductNameCellSearchContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start',
  width: '100%',
})

export const SearchInputContainer = styled('div')({
  width: '100%',
})

export const SuggestionListActionContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  padding: '0px 8px',
})

export const SuggestionListActionWrapper = styled('div')(({ theme }) => ({
  padding: '4px 0px',
  borderTop: `1px solid ${theme.palette.divider}`,
  width: '100%',
}))

export const StyledBrowseComponentsButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  textAlign: 'left',
  justifyContent: 'flex-start',
  width: '100%',
  '&:hover': {
    backgroundColor: theme.palette.blue[200],
  },
}))

export const StyledRequestReviewQuoteButton = styled(Button, { name: 'StyledRequestReviewQuoteButton' })({
  width: '100%',
  minWidth: 0,
  '& .MuiButton-startIcon': {
    flexShrink: 0,
  },
})

export const StyledRequestReviewQuoteButtonLabel = styled('span', { name: 'StyledRequestReviewQuoteButtonLabel' })({
  display: 'block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  minWidth: 0,
})
